import React from 'react';
import classNames from 'clsx';
import MenuContent from '../MenuContent/MenuContent';
import type { NavbarProps } from '../../Menu.types';
import directionStyles from '../../../../../common-styles/direction.module.scss';
import classes from './Navbar.module.scss';
import { selectors } from '../../constants';
import { useService } from '@wix/services-manager-react';
import type { IEnvironmentService } from '@wix/viewer-service-environment/definition';
import { EnvironmentDefinition } from '@wix/viewer-service-environment/definition';

export const NavbarMenu: React.FC<NavbarProps> = props => {
  const { getLanguageDirection } = useService(
    EnvironmentDefinition,
  ) as IEnvironmentService;
  const siteDirection = getLanguageDirection();

  const {
    id,
    className,
    submenuDirection,
    direction = siteDirection,
    onItemClick,
    onItemDblClick,
    onItemMouseIn,
    onItemMouseOut,
  } = props;

  return (
    <MenuContent
      id={`${id}-menu-content`}
      navbarClassName={classNames(
        selectors.navbar,
        classes.navbar,
        className,
        classes[direction],
      )}
      directionClassName={directionStyles.fallbackDirection}
      direction={direction as any}
      submenuDirection={submenuDirection as any}
      onItemClick={onItemClick}
      onItemDblClick={onItemDblClick}
      onItemMouseIn={onItemMouseIn}
      onItemMouseOut={onItemMouseOut}
    />
  );
};
